<template>
  <div>
    <v-layout class="pull-left">
      <v-dialog :modelValue="show" max-width="550px" @keydown.esc="$emit('close')" @click:outside="$emit('close')">
        <v-card>
          <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="print">

            <v-card-title>
              <span class="headline">Imprimir etiqueta testigo - SO Nº {{ shipmentOrder ? shipmentOrder.code : '' }}</span>
            </v-card-title>

            <v-card-text class="mt-4">
              <v-combobox
                v-model="item.measure"
                name="measure"
                item-title="name"
                item-value="id"
                :items="measures"
                label="Medidas de papel*"
                autocomplete="off"
                :rules="[rules.requiredComboBox]"
              ></v-combobox>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="$emit('close')">Cancelar</v-btn>
              <v-btn color="success" text type="submit" :loading="loading">Imprimir</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";

export default {
  name: "ModalPrintWitnessShipment",
  mixins: [ValidMixin],
  props: {
    show: Boolean,
    shipmentOrder: Object,
  },
  data() {
    return {
      loading: false,
      item: { measure: { id: 1, name: "A4" } },
      defaultItem: { measure: { id: 1, name: "A4" } },
      measures: [
        { id: 1, name: "A4" },
        { id: 2, name: "10x15" },
        { id: 3, name: "10x8" },
      ],
    };
  },
  watch: {
    show() {
      this.item = JSON.parse(JSON.stringify(this.defaultItem));
    },
  },
  methods: {
    print() {
      if (this.loading) return;
      if (!this.valid) return;

      const measureValue = this.item.measure?.name;
      if (!measureValue) {
        this.toast.error("Debe seleccionar una medida de papel");
        return;
      }

      this.loading = true;

      shipmentOrderService
        .printWitness(this.shipmentOrder.id, { measure: measureValue })
        .then((response) => {
          try {
            let result = JSON.parse(this.arrayBufferToString(response.data));
            if (!result.status) {
              this.toast.error(result.msg);
            }
          } catch (e) {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Testigo-SO-${this.shipmentOrder.code}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
            this.toast.success("Etiqueta testigo descargada correctamente");
            this.item = JSON.parse(JSON.stringify(this.defaultItem));
            this.$emit("close");
          }
        })
        .catch(() => {
          this.toast.error("Error al imprimir la etiqueta testigo");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    arrayBufferToString(buffer) {
      var arr = new Uint8Array(buffer);
      var str = String.fromCharCode.apply(String, arr);
      if (/[\u0080-\uffff]/.test(str)) {
        throw new Error("this string seems to contain (still encoded) multibytes");
      }
      return str;
    },
  },
};
</script>
